// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"D8-z"};